import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
//Services
import { LoaderService } from "src/app/services/loader/loader.service";
import { RouterService } from "src/app/services/router/router.service";
import { AuthService } from "src/app/services/auth/auth.service";
import { UserService } from "src/app/services/user/user.service";
import { RemoteConfigService } from "src/app/services/remote-config/remote-config.service";
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { TagsService } from "src/app/services/tags/tags.service";
import { PlatformService } from "src/app/services/platform/platform.service";
import { AlertService } from "src/app/services/alert/alert.service";
import { ChangeEmailPage } from "../../public/change-email/change-email.page";
import { ChangePhonePage } from "../change-phone/change-phone.page";
import { environment } from "src/environments/environment";
import { TYPES_REGISTER } from "../../public/register/register.page";
@Component({
  selector: "app-profile-detail",
  templateUrl: "./profile-detail.page.html",
  styleUrls: ["./profile-detail.page.scss"],
})
export class ProfileDetailPage implements OnInit {
  userForm: FormGroup;
  LOADER_ID = "profile-detail";
  authMethods: any = {};
  dynamicForm: any = [];
  showExtraInfo: boolean = true; // use when you need yo add additional login chat fields
  backupInfo: any;
  register_type
  TYPES_REGISTER = TYPES_REGISTER;
  constructor(
    private formBuilder: FormBuilder,
    private loaderService: LoaderService,
    public authService: AuthService,
    public userService: UserService,
    public routerService: RouterService,
    public languageService: LanguagesService,
    private remoteConfig: RemoteConfigService,
    private tagsService: TagsService,
    private platformService: PlatformService,
    private alertService: AlertService
  ) {
    this.userForm = this.formBuilder.group({
      document: ["", Validators.required],
      name: ["", Validators.required],
      lastName: [""],
      email: [""],
      phone: [""]
    });
  }
  ionViewDidEnter() {
    this.getUserType();
  }

  ngOnInit() {
    this.tagsService.setEventTag(
      "profile_detail_page",
      "profile_detail_screen_viewed",
      false,
      true
    );
    this.fillForm();
    this.getAuthMethods();
  }
  getUserType() {
    const body = {
      app_id: environment.gluky.app_id,
    }
    this.authService.getRegisterConfigData(body).subscribe( (res: any) => { 
       this.register_type = res[0]?.register_type ?? TYPES_REGISTER.iddoc;
    })
    
  }

  async sendForm() {
    await this.loaderService.presentLoading(this.LOADER_ID);
    try {
      var data = Object.assign({}, this.userForm.value);
      console.log('Object.assign({} data 1', data);
      
      data["docNumber"] = data["document"];
      data["lastnames"] = data["lastName"];
      delete data["lastName"];
      delete data["document"];
      if(!data["phone"]){
        delete data["phone"];
      }
      if(!data["email"]){
        delete data["email"];
      }
      if(!data["iddoc"])  delete data["iddoc"];
      if(!data["iddoc_type"])  delete data["iddoc_type"];
      console.log('Object.assign({} data 2', data);
      await this.updateProfile(data);
      await this.loaderService.cancelLoader(this.LOADER_ID);
    } catch (err) {
      await this.loaderService.cancelLoader(this.LOADER_ID);
    }
  }

  updateProfile(data){
    const body = {
      "name": data["name"],
      "last_name": data["lastnames"],
      "iddoc": data["docNumber"],
      "iddoc_type": this.backupInfo.docType,
      "phone": data["phone"],
      "email": data["email"]
    }
    if(!data["phone"]){
      delete body["phone"];
    }
    if(!data["email"]){
      delete body["email"];
    }
    if(!body["iddoc"])  delete body["iddoc"];
    if(!body["iddoc_type"])  delete body["iddoc_type"];
    
    console.log('Object.assign({} body 1', body);
    this.authService.updateProfile(body).subscribe(async (res: any) => {
      console.log(res)
      await this.userService.saveUserExtraInfo(data).then(()=>{
        this.alertService.presentAlert('Información Actualizada Correctamente')
      }).catch(err => {
        console.log('Fallo al guardar información extra catch(err =>', err)
      });
    }, error => {
      const Errors = {
        IDDOC_USED:{
          code:'IDDOC_USED',
          text:'Documento En Uso'
        }
      }
      this.alertService.presentAlert(Errors[error.error.code].text)
      if (error.error.code == Errors.IDDOC_USED.code) {
        this.userForm.controls.document.setValue(this.backupInfo.document)
      }
      console.error(error);
    })
  }

  async fillForm() {
    const data: any = {};
    await this.loaderService.presentLoading(this.LOADER_ID);

    try {
      //LOGIN_CHAT
      await this.remoteConfig
        .getLoginChat()
        .toPromise()
        .then(
          (chatInfo) =>
            (this.dynamicForm = chatInfo.filter(
              (field) => field.in_profile_page == true
            ))
        );

      this.dynamicForm.forEach((dynamicField) =>
        this.userForm.addControl(
          dynamicField.name,
          new FormControl("", Validators.maxLength(dynamicField.max_length))
        )
      );

      const userFirebase = await this.authService.getUSerInfoFromFirebase();
      this.userService.getUserInfo().subscribe(
        async (basicUserInfo: any) => {
          data.email = userFirebase.email.split('@')[1] == 'nomail.glukynet.com' ? '' : userFirebase.email;
          data.phone = userFirebase.phoneNumber || basicUserInfo.phone;
          data.name = basicUserInfo.name;
          data.document = basicUserInfo.gnxCredential1;
          data.lastName = basicUserInfo.lastnames;
          data.docType = basicUserInfo.docType;
          this.backupInfo = data;
          this.dynamicForm.forEach(
            (dynamicField) =>
              (data[dynamicField.name] = basicUserInfo[dynamicField.name])
          );
          this.userForm.patchValue(data);
          await this.loaderService.cancelLoader(this.LOADER_ID);
        },
        async (err) => {
          await this.loaderService.cancelLoader(this.LOADER_ID);
        }
      );
    } catch (err) {
      this.loaderService.cancelLoader(this.LOADER_ID);
    }
  }

  async changeEmail() {
    if (this.register_type != TYPES_REGISTER.email) {
      return this.routerService.redirect("change-email", ChangeEmailPage, null, "gnx-modal-absolute gnx-modal-xs ", null, "changeEmail");
    } else {
      this.alertService.presentAlert(this.getTextIUProfileDetail.alert_change_email_not_allowed)
    }
  }
  async changePhone() {
    return this.routerService.redirect("change-phone", ChangePhonePage, null, "gnx-modal-absolute gnx-modal-xs", null, "changePhone");
  }
  get getTextIUProfileDetail() {
    return this.languageService.textsIU.page_profile_detail;
  }

  getAuthMethods = () => {
    this.remoteConfig.getSettingsAuthMethods().subscribe((res) => {
      this.authMethods = res;
    });
  };

 
}
